/** アラート画面（route 層）の TanStack Query key ルート。invalidate と route で共有する。 */
export const deviceAssignmentAlertKeys = {
  all: ['device-assignment-alerts'] as const
} as const;